import { getCredentials } from './utils/auth'

function getHeaders(headers: HeadersInit = {}, body: unknown | undefined): HeadersInit {
  const credentials = getCredentials()

  let finalHeaders = headers

  if (body !== undefined) {
    finalHeaders = {
      'Content-type': 'application/json',
      ...finalHeaders,
    }
  }

  if (credentials !== null) {
    finalHeaders = {
      Authorization: 'Basic ' + btoa(`${credentials.username}:${credentials.password}`),
      ...finalHeaders,
    }
  }

  return finalHeaders
}

const _fetch = async (url: string, opts: RequestInit = {}): Promise<Response> => {
  const { body, ...options } = opts
  return await fetch(url, {
    ...options,
    body,
    headers: getHeaders(opts.headers, body),
  })
}

export default _fetch
